module.exports = __webpack_public_path__ + "h5/img/cs_04.bdbe84de.jpeg";